import React, { Component } from 'react';
import { Row, Col, Label, InputGroup, Button } from "reactstrap";
import { inject, observer } from "mobx-react";
import Card from "../../comum/components/Card";
import InputFiltro from "../../comum/components/InputFiltro";
import FormSelectSimples from "../../comum/components/FormSelectSimples";
import CalendarioPicker from "../../comum/components/Calendario";
import FiltrosServicoStore from "../stores/FiltrosAcompServicoStore";
import { FecharFiltro, Filtro } from "../../comum/components/Icones";
import { isInvalidoCodigoContainer } from "../../../utils/validadores";
import FormInputSimples from "../../comum/components/FormInputSimples";

@inject("store")
@observer
export default class FiltrosAcompServicos extends Component {
    constructor(props) {
        super(props);

        this.controllerServico = this.props.controller;
        this.controller = new FiltrosServicoStore(this.props.service);

        this.state = { maisFiltros: false, filtrado: false };
    };

    handleFiltrar() {
        this.setState(state => ({ filtrado: true }));
        if (this.validar()) {
            _.set(this.controller.filtros, "parcidId", this.controller.clienteSelecionado ? this.controller.clienteSelecionado.value : null);
            _.set(this.controller.filtros, "tipoServId", this.controller.subgrupoSelecionado ? this.controller.subgrupoSelecionado.value : null);
            _.set(this.controller.filtros, "status", this.controller.statusSelecionado ? this.controller.statusSelecionado.value : null);
            this.controllerServico.listar(this.controller.filtros);
        }
    };

    // Cliente agora é opcional
    validar = () => {
        return (
            this.controller.filtros.container.length === 0 ||
            !isInvalidoCodigoContainer(this.controller.filtros.container)
        );
    };

    filtros = () => {
        if (!this.state.maisFiltros) {
            return this.filtrosBasicos();
        } else {
            return this.filtrosCompletos();
        }
    };

    filtrosBasicos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return (
            <React.Fragment>
                <FormSelectSimples titulo="Cliente" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                   itens={this.controller.clientes}
                                   dado={this.controller.clienteSelecionado}
                                   bloqueado={!this.controller.clientes}
                                   onChange={(event) => this.controller.onChangeCliente(event)} />
                <InputFiltro titulo="BL" xl={xl} lg={lg} md={md} sm={12} xs={12}
                             onChange={(event) => this.controller.onChangeFiltro("numeroBl", event)} />
                <FormInputSimples titulo="Container" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                  alerta={
                                      (this.state.salvado && this.controller.filtros.container.length === 0)
                                      || (this.controller.filtros.container.length > 0 && isInvalidoCodigoContainer(this.controller.filtros.container))
                                          ? "Formato: HHHH1234567"
                                          : false
                                  }
                                  onChange={(event) => this.controller.onChangeFiltro("container", event)} />
                <Col xl={3} lg={lg} md={md} sm={12} xs={12} className="mb-4">
                    <div className="w-100">
                        <Col xs={12} className="col-label px-0">
                            <Label>Período</Label>
                        </Col>
                        <Col xs={12} className="px-0">
                            <InputGroup className={'ativo'}>
                                <CalendarioPicker
                                    onChangeInicio={valor => this.controller.onChangeDataInicio(valor)}
                                    onChangeFim={valor => this.controller.onChangeDataFim(valor)}
                                    dataInicial={this.controller.filtros.dataInicial}
                                    dataFinal={this.controller.filtros.dataFinal}
                                    fechar={this.controller.toggleDataSeletor}
                                    filtrar={() => { }}
                                />
                            </InputGroup>
                        </Col>
                    </div>
                </Col>
                <Col className="col-botoes" xl={3} lg={3} md={3} sm={12} xs={12}>
                    <Button className="btn-filtros" onClick={() => this.mudaFiltros()} outline>
                        <Filtro color="#93A0AD" className="mr-2" width="15" height="15" />
                        Mais filtros
                    </Button>
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.handleFiltrar()}>Filtrar</Button>
                </Col>
            </React.Fragment>
        );
    };

    filtrosCompletos = () => {
        let xl = 3; let lg = 4; let md = 4;
        return (
            <React.Fragment>
                <FormSelectSimples titulo="Cliente" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                   itens={this.controller.clientes}
                                   dado={this.controller.clienteSelecionado}
                                   bloqueado={!this.controller.clientes}
                                   onChange={(event) => this.controller.onChangeCliente(event)} />
                <InputFiltro titulo="BL" xl={xl} lg={lg} md={md} sm={12} xs={12}
                             onChange={(event) => this.controller.onChangeFiltro("numeroBl", event)} />
                <FormInputSimples titulo="Container" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                  alerta={
                                      (this.state.salvado && this.controller.filtros.container.length === 0)
                                      || (this.controller.filtros.container.length > 0 && isInvalidoCodigoContainer(this.controller.filtros.container))
                                          ? "Formato: HHHH1234567"
                                          : false
                                  }
                                  onChange={(event) => this.controller.onChangeFiltro("container", event)} />
                <Col xl={xl} lg={lg} md={md} sm={12} xs={12} className="mb-4">
                    <div className="w-100">
                        <Col xs={12} className="col-label px-0">
                            <Label>Período</Label>
                        </Col>
                        <Col xs={12} className="px-0">
                            <InputGroup className={'ativo'}>
                                <CalendarioPicker
                                    onChangeInicio={valor => this.controller.onChangeDataInicio(valor)}
                                    onChangeFim={valor => this.controller.onChangeDataFim(valor)}
                                    dataInicial={this.controller.filtros.dataInicial}
                                    dataFinal={this.controller.filtros.dataFinal}
                                    fechar={this.controller.toggleDataSeletor}
                                    filtrar={() => { }}
                                />
                            </InputGroup>
                        </Col>
                    </div>
                </Col>
                <FormSelectSimples titulo="Grupo de serviços" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                   itens={this.controller.grupos}
                                   dado={this.controller.grupoSelecionado}
                                   bloqueado={!this.controller.grupos}
                                   onChange={(event) => this.controller.onChangeGrupo(event)} />
                <FormSelectSimples titulo="Subgrupo de serviços" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                   itens={this.controller.subgrupos}
                                   dado={this.controller.subgrupoSelecionado}
                                   bloqueado={!this.controller.subgrupos}
                                   onChange={(event) => this.controller.onChangeSubgrupo(event)} />
                <FormSelectSimples titulo="Status" xl={xl} lg={lg} md={md} sm={12} xs={12}
                                   itens={this.controller.status}
                                   dado={this.controller.statusSelecionado}
                                   bloqueado={!this.controller.status}
                                   onChange={(event) => this.controller.onChangeStatus(event)} />
                <Col className="col-botoes" xl={xl} md={md} sm={12} xs={12}>
                    <Button className="btn-filtros ativo" onClick={() => this.mudaFiltros()} outline>
                        <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15" />
                        Menos filtros
                    </Button>
                    <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.handleFiltrar()}>Filtrar</Button>
                </Col>
            </React.Fragment>
        );
    };

    mudaFiltros = () => {
        this.setState({ maisFiltros: !this.state.maisFiltros });
    };

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        {this.filtros()}
                    </Row>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamentoservico/components/FiltrosAcompServicos.js